import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { useDeliveryBar } from '@context/DeliveryBarContext';
import { trackEvent } from '@monofront/tracking';

import type { JSX } from "react";

/**
 * Props for `DeliveryBarCta`.
 */
export type DeliveryBarCtaProps =
  SliceComponentProps<Content.DeliveryBarCtaSlice>;

/**
 * Component for "DeliveryBarCta" Slices.
 */
const DeliveryBarCta = ({
  prismicContent,
}: {
  prismicContent: DeliveryBarCtaProps['slice'];
}): JSX.Element => {
  const { setIsSidePanelOpen } = useDeliveryBar();

  return (
    <section
      data-slice-type={prismicContent.slice_type}
      data-slice-variation={prismicContent.variation}
      className="tw-flex tw-justify-center"
    >
      <button
        className="tw-lf-button tw-lf-button-primary tw-lf-button-md"
        onClick={() => {
          setIsSidePanelOpen(true);
          trackEvent({
            type: 'LFDisplayDeliveryBar',
          });
        }}
      >
        {prismicContent.primary.label}
      </button>
    </section>
  );
};

export default DeliveryBarCta;
